export const facilitiesStyles = {
	display: 'block',
	border: '1px',
	borderColor: 'neutrals.primary',
	borderStyle: 'solid',
	borderRadius: '0.5rem',
	textTransform: 'none',
};
